module.exports = __webpack_public_path__ + "img/xny1.0c601b13.png";